import {connect} from "react-redux"
import State from "../../../../models/State"

export const mapStateToProps = (state: State) => {
    return {
        altText: state.text.imageAlts.searchBannerChevron,
    }
}

export default connect(mapStateToProps)
